import { createTheme } from "@mui/material/styles";

const darkTheme = createTheme({});

const lightTheme = createTheme({
  spacing: 5,
  palette: {
    common: {
      black: "#000",
      white: "#fff",
    },
    background: {
      default: "#F6F6F6",
      paper: "#fff",
    },
    primary: {
      main: "#F1270B",
      // contrastText: "#000", 반전컬러 ex) contained버튼의 글씨 색상
    },
    warning: {
      main: "#F1270B",
    },
    secondary: {
      main: "#333333",
      // contrastText: "#000", 반전컬러 ex) contained버튼의 글씨 색상
    },
    info: {
      main: "#8E8E8E",
      light: "#E9E9E9",
      // contrastText: "#000", 반전컬러 ex) contained버튼의 글씨 색상
    },
    text: {
      primary: "#000",
      disabled: "#8E8E8E",
    },
    grey: {
      100: "#eee",
      200: "#E9E9E9",
      300: "#CFCFCF",
      400: "#BAC9D1",
      500: "#ccc",
    },
    action: {
      disabled: "#dfdfdf",
    },
  },
  typography: {
    fontFamily:
      "'NanumSquareRound', 'Malgun gothic','맑은고딕', Dotum, '돋움', arial, sans-serif",
  },

  props: {
    MuiButtonBase: {
      disableRipple: true,
      // disableFocusRipple: true,
      disablefocusripple: "true",
    },
    MuiButton: {
      disableRipple: true,
      disableElevation: true,
    },
    MuiInput: {
      disableripple: "true",
      disableUnderline: true,
      autoComplete: "off",
    },
    MuiInputLabel: {
      shrink: true,
      focused: false,
    },
    MuiRadio: {},
  },

  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          // "font-family": "Rubik",
          "font-size": "12px",
        },
      },
    },
  },
});

export { lightTheme, darkTheme };
